import { FormattedMessage } from "react-intl";

import { ButtonProps, Button } from "ui/Button/Button";

import { usePickingActions } from "../hooks/usePickingActions";
import { usePickingStore } from "../stores/usePickingStore";

type EndPickingButtonProps = {
  isButtonDisabled?: boolean;
  beforeSubmit?: () => void;
} & ButtonProps;

export function EndPickingButton({
  isButtonDisabled = false,
  beforeSubmit = () => {},
  ...rest
}: EndPickingButtonProps) {
  const { endPicking, retryEndPicking } = usePickingActions();
  const endPickingLoading = usePickingStore((state) => state.endPickingPhase === "loading");
  const endPickingError = usePickingStore((state) => state.endPickingPhase === "error");

  const isDisabled = isButtonDisabled || endPickingLoading;
  const onClickButton = () => {
    if (isDisabled) return;
    beforeSubmit();
    if (endPickingError) {
      retryEndPicking();
    } else {
      endPicking();
    }
  };

  const buttonLabelId = endPickingError
    ? "components.picking.end-picking-button.button-label-retry-end-picking"
    : "components.picking.end-picking-button.button-label-finish-picking";

  return (
    <Button
      isLoading={endPickingLoading}
      isDisabled={isDisabled}
      onClick={onClickButton}
      size="lg"
      isFullWidth
      data-testid="finish-picking-button"
      {...rest}
    >
      <FormattedMessage id={buttonLabelId} />
    </Button>
  );
}
